import { Component, Input, OnInit } from '@angular/core';
import { Node } from 'src/app/classes/node';
import { SimulationState } from 'src/app/enums/simulation.state.enum';

@Component({
  selector: 'app-log-box',
  templateUrl: './log-box.component.html',
  styleUrls: ['./log-box.component.scss']
})
export class LogBoxComponent implements OnInit {

  @Input() numMsgsInCirculation: number = 0;
  @Input() curNodeDegree: number = -1;
  @Input() simState: SimulationState = SimulationState.ABACI_TRAINING;

  simStateName = SimulationState[this.simState];

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges() {
    this.simStateName = SimulationState[this.simState];
  }




}
